import React, { useRef } from "react";
import { User } from "~/common/Store/models/User";
import SignupAndSaveBanner from "../SignupAndSaveBanner";
import WebPlusShippingAd from "~/common/Ads/WebPlusAd/WebPlusShippingAd";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import useCustomerIoMutationObserver from "~/common/hooks/useCustomerIoMutationObserver";
import withMounted from "~/common/hocs/withMounted";
interface PlusAdProps {
  user: User;
}
const PlusAd = withUserAndChat(({
  user
}: PlusAdProps) => {
  const [cioAdPresent, setCioAdPresent] = React.useState(false);
  const isLoggedIn = user?.isLoggedIn ?? false;
  const cioAdRef = useRef<HTMLDivElement>(null);
  useCustomerIoMutationObserver({
    targetRef: cioAdRef,
    onMutation: mutated => setCioAdPresent(mutated)
  });
  return <>
      {isLoggedIn ? <>
          <div id="cio-homepage-plusad" ref={cioAdRef} />
          {!cioAdPresent && <WebPlusShippingAd mounted page="homepage" containerClass="container mb-6 xl:mb-10" headerClassCss="text-base pr-6 xsl:pr-0 sm:text-xl md:text-2xl xxl:text-3xl m-0 pb-1 text-gray-900 font-bold !leading-none" subheaderClassCss="my-0 text-gray-800 text-xs leading-[14px] pr-10 xxm:pr-3 sm:pr-0 sm:text-base sm:leading-none lg:text-lg lg:leading-none xxl:text-xl xxl:leading-none" />}
        </> : <>
          {user.hasWebPlus && <div id="cio-plusday-plusad" />}
          <SignupAndSaveBanner mounted user={user} />
        </>}
    </>;
});
export default withMounted(PlusAd);